<template>
    <div class="ba-franchise-index-v5">
        <links-user-v4 :props="this.view" v-if="this.view.IS_AMBASSADOR || this.view.IS_AMBASSADOR_PLUS"></links-user-v4>
        <div class="box-title-copy">
            <div class="header" v-html="this.view.translation.fs5_affiliate_dashboard"></div>
            <div class="header-link">
                <fs5-input-copy :view="['',affiliateLink,this.view.translation.copied]" :styleType="'link-affiliate'" :tooltip="this.view.translation.share_link_tooltip" :tooltipPosition="'right'"/>
              {{ decodeString(view.translation.normalLinksUser.your_affiliate_link) + '/ID: ' + view.dados_usuario_office.id }}
            </div>
        </div>

        <associate-tokens v-if="this.view.associate_tokens" :translations="this.view.translation.associate_tokens" :data="this.view.associate_tokens"></associate-tokens>

        <div class="content">
            <fs5-shared-collapse
                :view="{
                    title: view.translation.fs5_dashboard_builderall_tutorial,
                    content: {
                        translation:{
                            header: view.translation.header,
                            coming_soon: view.translation.coming_soon,
                            new: view.translation.new
                        },
                        urls: view.propsNewIndex.url_video_rank,
                        show_is_new_badge: view.propsNewIndex.url_video_show_new_badge,
                    }
                }"
            >
                <div
                    :slot="'content'"
                    slot-scope="props"
                >
                    <fs5-dashboard-tutorial :view="props.content" ></fs5-dashboard-tutorial>
                </div>
            </fs5-shared-collapse>

<!--          <div v-if="view.lang != 'br'" class="disable-withdraw">Due to the US Federal Holiday, commission withdrawal requests will close at 2pm ET, July 3rd, 2024.</div>-->

            <fs5-estimated-earns :view="{
                translation: this.view.translation.earningsForecast,
                cards: [
                    {
                        title: `${view.translation.earningsForecast.earnings_forecast_value_label} (BRL)`,
                        value: view.forecast_comissions.commission_previous_BRL
                    },
                    {
                        title: `${view.translation.earningsForecast.earnings_forecast_value_label} (EUR)`,
                        value: view.forecast_comissions.commission_previous_EUR
                    },
                    {
                        title: `${view.translation.earningsForecast.earnings_forecast_value_label} (USD)`,
                        value: view.forecast_comissions.commission_previous_USD
                    }
                ]
            }"/>

            <fs5-quick-links
                :view="{
                    header: {
                        title: this.view.autoresponder.translations.fs5_quick_links,
                        tooltip: this.view.autoresponder.translations.fs5_quick_links_tooltip,
                        showTooltip: false
                    },
                    buttons: quickLinksButtons
                }"
            />

            <fs5-link-generator :view="{
                header: {
                    title: this.view.translation.link_generator.link_generator,
                    tooltip: this.view.translation.fs5_link_generator_tooltip,
                    showTooltip: false
                },
                access_short_url: this.view.routes.access_short_url,
                can_access_short_url: this.view.can_access_short_url,
                buttons: linkGeneratorButtons
            }" />

            <fs5-funnel-club
                v-if="view.dados_usuario_office.affiliate_type == 'PRO'"
                :view="{
                    header: {
                        title: this.view.translation.button_onboarding_funnel,
                        tooltip: this.view.translation.fs5_funnel_club_tooltip,
                        showTooltip: false
                    },
                    content: {
                        text: this.view.translation.fs5_funnel_club_text,
                        button: {
                            label: this.view.translation.fs5_funnel_club_button,
                            textTransformType: 'capitalize',
                            btnType: 'primary',
                            link: this.view.urls.rota_office_onboarding_funnel
                        }
                    }
                }"
            />

            <fs5-earnings
                :view="{
                    header: {
                        title: this.view.translation.allValuesUser.earnings,
                        tooltip: this.view.translation.allValuesUser.label_tooltip_earnings
                    },
                    routes: this.view.routes,
                    userToken: this.view.data.user_token,
                    buttons:[
                        {
                            label: this.view.translation.allValuesUser.this_month,
                            textTransformType: 'capitalize',
                            btnType: '',
                        },
                        {
                            label: this.view.translation.allValuesUser.last_month,
                            textTransformType: 'capitalize',
                            btnType: '',
                        },
                        {
                            label: this.view.translation.allValuesUser.last_3_month,
                            textTransformType: 'capitalize',
                            btnType: '',
                        },
                        {
                            label: this.view.translation.allValuesUser.last_6_month,
                            textTransformType: 'capitalize',
                            btnType: '',
                        },
                        {
                            label: this.view.translation.allValuesUser.all_time,
                            textTransformType: 'capitalize',
                            btnType: '',
                        },
                    ],
                    cards: [
                        { /* card 1 */
                            title: this.view.translation.allValuesUser.all_earnings,
                            content1: [
                                {
                                    text: this.view.translation.allValuesUser.all_leads,
                                    value: '0'
                                },
                                {
                                    text: this.view.translation.allValuesUser.all_active_leads,
                                    value: '0'
                                },
                                {
                                    text: this.view.translation.allValuesUser.number_of_all_affiliates,
                                    value: '0'
                                }
                            ],
                            content2: [
                                {
                                    text: 'USD',
                                    value: '0'
                                },
                                {
                                    text: 'EUR',
                                    value: '0'
                                },
                                {
                                    text: 'BRL',
                                    value: '0'
                                }
                            ]
                        },
                        { /* card 2 */
                            title: this.view.translation.allValuesUser.first_tier_leads,
                            content1: [
                                {
                                    text: this.view.translation.allValuesUser.all_leads,
                                    value: '0'
                                },
                                {
                                    text: this.view.translation.allValuesUser.all_active_leads,
                                    value: '0'
                                },
                                {
                                    text: this.view.translation.allValuesUser.number_of_all_affiliates,
                                    value: '0'
                                }
                            ],
                            content2: [
                                {
                                    text: 'USD',
                                    value: '0'
                                },
                                {
                                    text: 'EUR',
                                    value: '0'
                                },
                                {
                                    text: 'BRL',
                                    value: '0'
                                }
                            ]
                        },
                        { /* card 3 */
                            title: this.view.translation.allValuesUser.tier_2_sales,
                            content1: [
                                {
                                    text: this.view.translation.allValuesUser.all_leads,
                                    value: '0'
                                },
                                {
                                    text: this.view.translation.allValuesUser.all_active_leads,
                                    value: '0'
                                },
                                {
                                    text: this.view.translation.allValuesUser.number_of_all_affiliates,
                                    value: '0'
                                }
                            ],
                            content2: [
                                {
                                    text: 'USD',
                                    value: '0'
                                },
                                {
                                    text: 'EUR',
                                    value: '0'
                                },
                                {
                                    text: 'BRL',
                                    value: '0'
                                }
                            ]
                        },
                    ]
                }"
            />

            <fs5-current-earnings :view="{
                header: {
                    title: this.view.translation.currentEarnings.label_seus_ganhos,
                    tooltip: this.view.translation.currentEarnings.fs5_current_earnings_tooltip,
                    showTooltip: false
                },
                button: {
                    label: this.view.translation.currentEarnings.label_get_paid,
                    textTransformType: 'capitalize',
                    btnType: 'primary',
                    link: this.view.urls.rota_ganhos
                },
                cards: [
                    {
                        title: this.view.translation.currentEarnings.waiting,
                        tooltip: this.view.translation.currentEarnings.dash_business_tooltip_waiting,
                        earns: [
                            {
                                text:  'USD',
                                value: `$ ${ (view.totais_ganhos.USD.A_RECEBER ? view.totais_ganhos.USD.A_RECEBER.valor : 0) }`
                            },
                            {
                                text:  'EUR',
                                value: `€ ${ (view.totais_ganhos.EUR.A_RECEBER ? view.totais_ganhos.EUR.A_RECEBER.valor : 0) }`
                            },
                            {
                                text:  'BRL',
                                value: `R$ ${ (view.totais_ganhos.BRL.A_RECEBER ? view.totais_ganhos.BRL.A_RECEBER.valor : 0) }`
                            },
                        ]
                    },
                    {
                        title: this.view.translation.currentEarnings.available,
                        tooltip: this.view.translation.currentEarnings.dash_business_tooltip_available,
                        earns: [
                            {
                                text:  'USD',
                                value: `$ ${ (view.totais_ganhos.USD.NAO ? view.totais_ganhos.USD.NAO.valor : 0) }`
                            },
                            {
                                text:  'EUR',
                                value: `€ ${ (view.totais_ganhos.EUR.NAO ? view.totais_ganhos.EUR.NAO.valor : 0) }`
                            },
                            {
                                text:  'BRL',
                                value: `R$ ${ (view.totais_ganhos.BRL.NAO ? view.totais_ganhos.BRL.NAO.valor : 0) }`
                            },
                        ]
                    },
                    {
                        title: this.view.translation.currentEarnings.requested,
                        tooltip: this.view.translation.currentEarnings.dash_business_tooltip_requested,
                        earns: [
                            {
                                text:  'USD',
                                value: `$ ${ (view.totais_ganhos.USD.SOLICITADO ? view.totais_ganhos.USD.SOLICITADO.valor : 0) }`
                            },
                            {
                                text:  'EUR',
                                value: `€ ${ (view.totais_ganhos.EUR.SOLICITADO ? view.totais_ganhos.EUR.SOLICITADO.valor : 0) }`
                            },
                            {
                                text:  'BRL',
                                value: `R$ ${ (view.totais_ganhos.BRL.SOLICITADO ? view.totais_ganhos.BRL.SOLICITADO.valor : 0) }`
                            },
                        ]
                    },
                    {
                        title: this.view.translation.currentEarnings.paid,
                        tooltip: this.view.translation.currentEarnings.dash_business_tooltip_paid,
                        earns: [
                            {
                                text:  'USD',
                                value: `$ ${ (view.totais_ganhos.USD.SIM ? view.totais_ganhos.USD.SIM.valor : 0) }`
                            },
                            {
                                text:  'EUR',
                                value: `€ ${ (view.totais_ganhos.EUR.SIM ? view.totais_ganhos.EUR.SIM.valor : 0) }`
                            },
                            {
                                text:  'BRL',
                                value: `R$ ${ (view.totais_ganhos.BRL.SIM ? view.totais_ganhos.BRL.SIM.valor : 0) }`
                            }
                        ]
                    },
                ]
            }" />

            <fs5-disclosure :view="{
                header: {
                    title: this.view.translation.graphicDisclosures.fs5_disclosure_title,
                    tooltip: this.view.translation.graphicDisclosures.fs5_disclosure_tooltip,
                    showTooltip: false
                },
                content: {
                    left: {
                        title: this.view.translation.graphicDisclosures.fs_disclosure_left_title,
                        subtitle: this.view.translation.graphicDisclosures.fs_disclosure_left_subtitle,
                        chartLabel: this.view.translation.graphicDisclosures.fs_disclosure_left_chart_label,
                        buttons: [
                            {
                                label: this.view.translation.graphicDisclosures.today,
                                textTransformType: 'capitalize',
                                btnType: 'white2',
                                btnTypeActive: 'default',
                                period: 'day'
                            },
                            {
                                label: this.view.translation.graphicDisclosures.month,
                                textTransformType: 'capitalize',
                                btnType: 'white2',
                                btnTypeActive: 'default',
                                period: 'month'
                            },
                            {
                                label: this.view.translation.graphicDisclosures.year,
                                textTransformType: 'capitalize',
                                btnType: 'white2',
                                btnTypeActive: 'default',
                                period: 'year'
                            },
                        ]
                    },
                    right: {
                        labelUrl: this.view.translation.graphicDisclosures.label_url,
                        access: this.view.translation.graphicDisclosures.access,
                        registration: this.view.translation.graphicDisclosures.registration,
                        disclosureEmpty: this.view.translation.graphicDisclosures.disclosure_empty
                    }
                },
                buttons: [
                    {
                        label: this.view.translation.general.label_click_for_rank_definitions,
                        textTransformType: 'capitalize',
                        btnType: 'white',
                        link: this.view.urls.rota_ranking
                    },
                    {
                        label: this.view.translation.general.label_compensation_plan_details,
                        textTransformType: 'capitalize',
                        btnType: 'white',
                        link: this.view.urls.rota_affiliates
                    },
                ]
            }" />

            <fs5-affiliate-profile :view="{
                header: {
                    title: this.view.translation.start_here_resources_title,
                    tooltip: '',
                    showTooltip: false
                },
                content: {
                    left: {
                        title: this.view.translation.start_here_bio_label,
                        remainingCharacter: this.view.translation.label_caracter_restante,
                        button: {
                            label: this.view.translation.button_salvar,
                            textTransformType: 'capitalize',
                            btnType: 'primary',
                            link: this.view.routes.rota_office_handler_usuarios_complement
                        }
                    },
                    right: {
                        title: this.view.translation.start_here_gravatar_label,
                        emailLabel: this.view.translation.email,
                        buttons: [
                            {
                                label: this.view.translation.start_here_setup_gravatar,
                                textTransformType: 'capitalize',
                                btnType: 'primary',
                                link: 'https://en.gravatar.com/connect/'
                            },
                            {
                                label: this.view.translation.button_salvar,
                                textTransformType: 'capitalize',
                                btnType: 'default',
                                disabled: true
                            },
                        ],
                        affiliateLink: {
                            label: this.view.translation.normalLinksUser.your_affiliate_link,
                            link: this.view.link_user ? this.view.link_user : false,
                            copy: this.view.translation.normalLinksUser.copy
                        }
                    }
                },
                dados_usuario_office: this.view.dados_usuario_office
            }" />
        </div>
    </div>
</template>

<script>
    export default {
        name: "ba-franchise-index-v5",
        props: ['view'],
        data(){
            return {
                affiliateLink: this.view.link_user ? this.view.link_user : false,
                linkGeneratorButtons: {
                    row1: [
                        {
                            label: this.view.translation.link_generator.office2_autopilot_share_urlredir,
                            textTransformType: 'uppercase',
                            btnType: 'white',
                            icon: '/internacional/public/office5/img/franchise_dashboard/svg/redirect_link.svg',
                            callback: 'toggleModalRedirectLinkEventListener'
                        },
                        {
                            label: this.view.translation.link_generator.link_generator_magic_funnel,
                            textTransformType: 'uppercase',
                            btnType: 'white',
                            icon: '/internacional/public/office5/img/franchise_dashboard/svg/magic_funnel.svg',
                            callback: 'toggleModalMagicFunnelEventListener'
                        }
                    ],
                    row2: [
                        {
                            label: this.view.translation.link_generator.link_generator_whatsapp,
                            textTransformType: 'uppercase',
                            btnType: 'white',
                            icon: '/internacional/public/office5/img/franchise_dashboard/svg/whatsapp.svg',
                            callback: 'toggleModalWhatsappEventListener'
                        },
                        {
                            label: this.view.translation.link_generator.link_generator_telegram,
                            textTransformType: 'uppercase',
                            btnType: 'white',
                            icon: '/internacional/public/office5/img/franchise_dashboard/svg/telegram.svg',
                            callback: 'toggleModalTelegramEventListener'
                        },
                        {
                            label: this.view.translation.link_generator.link_generator_url_shortener,
                            textTransformType: 'uppercase',
                            btnType: 'white',
                            icon: '/internacional/public/office5/img/franchise_dashboard/svg/url_shortner.svg',
                            callback: 'accessShortUrl'
                        }
                    ]
                }
            }
        },
        methods: {
            copyToClipboard: function(){
                try {
                    let copyText = affiliateLink;
                    copyText.select();
                    let successful = document.execCommand("Copy");
                    let msg = successful ? 'successful' : 'unsuccessful';
                    console.log('Copying text command was ' + msg);
                    $('#copy-button').tooltip('show');
                    setTimeout(function() {
                        $('#copy-button').tooltip('hide')
                    }, 2000)
                } catch (err) {
                    console.log('Oops, unable to copy');
                }
            },
            decodeString(val) {
              return new DOMParser().parseFromString(val, 'text/html').querySelector('body').textContent;
            }
        },
        computed: {
            quickLinksButtons() {
                if( this.view.user_domain_share !== undefined && this.view.user_domain_share !== null ) {
                    return [
                        {
                            label: this.view.autoresponder.translations.funnel_tab_autoresponder,
                            textTransformType: 'uppercase',
                            btnType: 'primary',
                            callback: 'toggleModalAutoresponderEventListener'
                        },
                        {
                            label: this.view.translation.domain.dns_ns_servers,
                            textTransformType: 'uppercase',
                            btnType: 'white',
                            callback: 'toggleModalModalDomainDNSEventListener'
                        },
                        {
                            label: this.view.translation.domain.office2_autopilot_share_desconectar_dominio,
                            textTransformType: 'uppercase',
                            btnType: 'orange',
                            callback: 'toggleModalDisconnectFunnelsEventListener'
                        }
                    ];
                } else {
                    return [
                        {
                            label: this.view.autoresponder.translations.funnel_tab_autoresponder,
                            textTransformType: 'uppercase',
                            btnType: 'primary',
                            callback: 'toggleModalAutoresponderEventListener'
                        },
                        {
                            label: this.view.translation.domain.label_conectar_dominio,
                            textTransformType: 'uppercase',
                            btnType: 'primary',
                            callback: 'toggleModalConnectFunnelsEventListener'
                        }
                    ];
                }
            }
        },
        created(){
        }
    }
</script>

<style scoped lang="scss">
    @import '../../../../scss/extras/_variables';
    .box-title-copy{
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 1em;
        .header-link{
            display: flex;
            align-items: center;
            justify-content: flex-end;
            flex-direction: column;
            gap: 9px;
            width: 29%;
            color: $fs5-color28;
            font-family: 'Lato';
            font-weight: bold;
            font-size: 13px;
        }
    }
    .ba-franchise-index-v5{
        font-family: $fs5-font2;
        font-size: 0.625rem;
        margin-right: 10px;
        .header{
            color: $fs5-color11;
            font-family: $fs5-font2;
            line-height: 1.2;
            font-weight: 900;
            font-size: 2.1875rem; /* 35px; */
            margin-bottom: 18px;
            text-transform: uppercase;
        }
        .content{
            font: inherit;
            display: flex;
            flex-direction: column;
            row-gap: 3.9em
        }
    }

    @media screen and (max-width: 1199px) {
        .ba-franchise-index-v5{
            .header{
                text-align: center;
            }
            .header-link{
                width: 40%;
            }
        }
    }
    @media screen and (max-width: 980px) {
        .box-title-copy{
            flex-direction: column;
            align-items: center;
            .header-link{
                width: 70%;
            }
        }
    }
</style>

<style lang="scss" >
    .modal-open {
        overflow: inherit!important;
        .modal{
            overflow-y: hidden;
        }
    }
    .disable-withdraw {
      font: inherit;
      font-size: 1.9em;
      line-height: 1.2;
      color: #FFF;
      text-align: center;
      background: #FF4848;
      border-radius: 4px;
      padding: .5em;
    }

</style>



// WEBPACK FOOTER //
// resources/office/js/components/franchise_v5/affiliate_dashboard/index.vue